module.exports = __webpack_public_path__ + "static/media/bah.ef1ac5d7.svg";